var $window = $(window),
    $header = $('.js-header'),
    $body = $('.js-body'),
    $footer = $('.js-footer'),

    wh = $window.height(),
    ww = $window.width(),
    wt = $window.scrollTop(),
    wb = wt + wh,
    wr = ww/wh,
    bodyScroll = wt,

    ft = $footer.offset().top,
    hh = $header.height(),

    vr = 16/9,

    screenSm = 600,
    screenMd = 900,
    screenLg = 1200,

    keydown = 0,

    heroImgLoaded = false,
    heroBgLoaded = false,
    bgVideoInit = false,

    lightboxIndex = 0,
    lightboxImgs = [];

var resizeTimer;